module.exports = __webpack_public_path__ + "img/pause-msg.592fe795.svg";